import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Dropdown extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    collapse: PropTypes.func,
    isOpen: PropTypes.bool,
  };

  render() {
    const { children, collapse, isOpen } = this.props;

    return (
      <div className={classNames('dropdown-menu', { open: isOpen })}>
        {React.cloneElement(children, { collapse })}
      </div>
    );
  }
}
